import React, { Component } from 'react';
// import ReactDOM from "react-dom";
import { connect } from 'react-redux';
// import * as Contracts from '../../Store/Contracts';
import * as Kyousai from './Saga/Kyousai';
import Button from '@material-ui/core/Button';

// import '../../Css/Grid.css';
import moment from 'moment'

const ReactDataGrid = require('react-data-grid');
interface Props {
  // get_banks: any,
  kyousais: any,
  shops: any,

  change_search_id: any,
  change_search_modal: any,
  change_grid_update: any,
  grid_update: any,
  change_search_detail: any,
  change_kyousais: any,
}



interface State {
  columns: any
  refresh: boolean
  list: any
  // state types
}


const DateFormatter = (payload: any) => {
  if (payload.value) {
    return moment(payload.value).format("YYYY/MM/DD");
  } else {
    return "";
  }
};



// const SelectFormatter =(payload:any) => {
//   console.log(payload)
//   if(payload.row.receipt_at && payload.row.payment_at){
//     // return moment(payload.value).format("YYYY/MM/DD");
//     return <div>　</div>
//   }else{
//     return <div  style={{background:"#CCC"}}>　</div>;
//   }
//   };

const conditionFormatter = (payload: any) => {
  if (payload.value) {
    return moment(payload.value).format("YYYY/MM/DD");
  } else {
    return "";
  }
};

const ContractFormatter = (payload: any) => {
  console.log(payload)
  if (payload.row.contract_cancel === 1) {
    return "キャンセル " + payload.row.contract_remarks;
  } else if (payload.row.contract_amount && payload.row.works === 1) {
    return payload.row.contract_amount + " " + payload.row.contract_remarks;
  } else if (payload.row.rent_m_etc_id === 3) {
    return "無し " + payload.row.contract_remarks;
  } else if (payload.row.rent_m_etc_id === 4 && payload.row.works === 1) {
    return "WEB " + payload.row.contract_remarks;
  } else if (payload.row.works === 2) {
    return "他社 " + payload.row.contract_remarks;
  } else if (payload.row.works === 3) {
    return "家主 " + payload.row.contract_remarks;
  } else {
    return "";
  }
};


const defaultColumnProperties = {
  sortable: true,
  // width: 120
};




/**
 *会計連動グリッド
 *
 * @class AccountingGridComponent
 * @extends {Component<Props, State>}
 */
class AccountingGridComponent extends Component<Props, State> {
  constructor(props: Readonly<Props>) {
    super(props);


    this.state = {
      refresh: false,
      columns: [
        {
          key: 'select', name: '選択', width: 60, resizable: true,
          //   formatter: SelectFormatter   
          //   , editable:  function (rowData:any) {
          //     return (rowData.receipt_at && rowData.payment_at) ? true : false;
          // }, 
        },
        { key: 'condition', name: '状況', width: 80, resizable: true },
        { key: 'application_at', name: '申込日', width: 90, resizable: true, formatter: DateFormatter },
        { key: 'nyuukyosha_name', name: '入居者名', width: 80, },
        { key: 'contractor', name: '契約者名', width: 80, resizable: true },
        { key: 'user_name', name: '担当', width: 50, resizable: true },
        { key: 'corse', name: 'コース', width: 80, resizable: true },
        { key: 'amount', name: '金額', width: 80, resizable: true },

        { key: 'pay_way', name: '支払方法', width: 80, resizable: true },
        // { key: 'tatemonoAddress1', name: '建物住所', width: 100,resizable: true },
        { key: 'tatemono_name', name: '建物名', width: 100, resizable: true },
        { key: 'room_name', name: '部屋名', width: 60, resizable: true },
        { key: 'start_at', name: '始期日', width: 90, resizable: true, formatter: DateFormatter },
        // { key: 'end_at', name: '終了日', width: 90, resizable: true, formatter: DateFormatter },
        { key: 'receipt_at', name: '領収日', width: 90, resizable: true, formatter: DateFormatter },
        // { key: 'payment_at', name: '入金日',width: 80, resizable: true, formatter: DateFormatter},
        { key: 'search', name: '結付', width: 60, resizable: true },
        { key: 'rent_contract_name1', name: '契約者名', width: 80, resizable: true },
        { key: 'rent_contract_tatemono_name', name: '建物名', width: 100, resizable: true },
        { key: 'rent_contract_room_name', name: '部屋名', width: 60, resizable: true },

        { key: 'contract_amount', name: '請求金額', width: 120, resizable: true, formatter: ContractFormatter },

        { key: 'delete', name: '消込', width: 60, resizable: true },
        // { key: 'contract_money', name: '契約金',width: 60, resizable: true },

        // { key: 'accounting_output_at', name: '出力日',width: 100, resizable: true },

      ].map(c => ({ ...c, ...defaultColumnProperties })),

      list: this.props.kyousais,



    };

    this.sortRows = this.sortRows.bind(this);
    this.SectionFormatter = this.SectionFormatter.bind(this);
    this.getCellActions = this.getCellActions.bind(this);
    this.getRowCount = this.getRowCount.bind(this);
    this.onGridRowsUpdated = this.onGridRowsUpdated.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
  }



  onGridRowsUpdated = ({ fromRow, toRow, updated }: any) => {


    let kyousais = this.props.kyousais.slice();
    // for (let i = fromRow; i <= toRow; i++) {
    //   kyousais[i] = { ...kyousais[i], ...updated };
    // }


    this.props.change_kyousais(kyousais)

  };

  SectionFormatter = (payload: any) => {

    const result = this.props.shops.filter((x: any) => x.tenpoNo === payload.value);

    return result[0].tenpoName;

  };


  componentWillMount() {

    // this.props.get_banks({output:true,name:"",date1:"",date2:""})


  }
  getSelectedCell(event: any) {
    alert()
  }

  // onRowClick = (rowIdx: any, row: any) => {
  onRowClick = (rowIdx: any) => {
    // console.log(rowIdx)
    // this.props.kyousais[rowIdx.rowIdx].condition = 1
    // this.props.kyousais.concat([])
    // row.condition = 1
    // this.setState({
    //   refresh: true
    // });
    // for (let i = fromRow; i <= toRow; i++) {
    //   kyousais[i] = { ...kyousais[i], ...updated };
    // }
    // kyousais[rowIdx].condition = 1
    // let kyousais = this.props.kyousais
    // this.props.change_kyousais(kyousais)
  }
  componentDidUpdate() {
    if (this.props.grid_update === true) {
      this.setState({
        refresh: true
      });
      this.props.change_grid_update(false)
    }
    // alert("update")
  }
  // this.props.get_banks({output:true,name:"",date1:"",date2:""})


  // rowGetter = (i:number) => {
  //     return this.props.rent_contracts_list[i];
  //   };

  onRowsSelected = (rows: any) => {
    console.log(rows)
    rows.forEach(function (r: any) {
      r.row.selected = true;
    });
    alert()
    this.forceUpdate();

  };

  onRowsDeselected = (rows: any) => {

    rows.forEach(function (r: any) {
      r.row.selected = false;
    });
    this.forceUpdate();
  };

  sortRows = (initialRows: any, sortColumn: any, sortDirection: any) => {


    const comparer = (a: any, b: any) => {
      if (sortDirection === "ASC") {

        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === "DESC") {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      } else {
        return 1;
      }

    };
    this.setState({ refresh: !this.state.refresh })
    return sortDirection === "NONE" ? initialRows : this.props.kyousais.sort(comparer);
  };




  getCellActions(column: any, row: any) {

    if (column.key === "select" && (row.receipt_at && row.rent_contract_id)) {
      return [{
        icon: <div className="float-right" style={{ textAlign: "center", paddingTop: "5px", paddingRight: "-5px", width: "100px", height: "100px", color: "green" }}>{row.select === 1 ? <i className="fas fa-check" style={{ marginLeft: "20px" }}></i> : ""}</div>,
        callback: () => {
          // row.select = row.select === 1 ? 0 : 1;

          let w = this.props.kyousais.map((q: any) => {
            if (q.id === row.id) return { ...q, select: row.select === 1 ? 0 : 1 };
            return q;
          })
          this.props.change_kyousais(w)
        }
      }]

    } else if (column.key === "select") {
      return [{
        icon: <div className="float-right" style={{ textAlign: "right", paddingRight: "2px", width: "100px", height: "40px", color: "#000000", background: "#CCC" }}> </div>,
        callback: () => {

          //   let estimateMonies2 = this.props.estimateMonies2

          //   if(estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].taxAmount>0){
          //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].taxAmount= 0
          //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].tax= false
          // }else{
          //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].taxAmount=  Math.round(row.amount*0.1)
          //     estimateMonies2.filter(a=>a.rentMAccountId===row.rentMAccountId)[0].tax= true
          // }

          //   this.props.change_estimateMonies2(estimateMonies2)
          //   this.props.check_estimates()
          //   this.setState({refresh:!this.state.refresh})
        }
      }]
    } else if (column.key === "delete") {



      return [{
        icon: <div className="float-right" style={{ textAlign: "center", paddingTop: "5px", paddingRight: "-5px", width: "100px", height: "100px", color: "#ff0000" }}>{row.delete === 1 ? <i className="fas fa-check" style={{ marginLeft: "20px" }}></i> : ""}</div>,
        callback: () => {
          // row.delete = row.delete === 1 ? 0 : 1;
          console.log(row.delete)
          let w = this.props.kyousais.map((q: any) => {
            if (q.id === row.id) return { ...q, delete: row.delete === 1 ? 0 : 1 };
            return q;
          })
          this.props.change_kyousais(w)
          // this.setState({ refresh: !this.state.refresh })
        }
      }]
    } else if (column.key === "search") {
      if (!row.rent_contract_name1) {
        return [{
          icon: <Button
            color="primary"
            variant="contained"
            size="small"
            type="submit"

            style={{ margin: 2, minWidth: 0, width: 50 }}
          // onClick={()=>this.add(12)}
          >検索
          </Button>,
          callback: () => {
            this.props.change_search_id(row.id)

            this.props.change_search_detail(row)
            // this.props.togglecontract()

            this.props.change_search_modal(true)
          }
        }]
      } else {
        return [{
          icon: <Button
            color="primary"
            variant="outlined"
            size="small"
            type="submit"
            disabled={row.processing ? true : false}
            style={{ margin: 2, minWidth: 0, width: 50 }}
          // onClick={()=>this.add(12)}
          >編集
          </Button>,
          callback: () => {
            if (!row.processing) {
              this.props.change_search_id(row.id)
              this.props.change_search_detail(row)
              this.props.change_search_modal(true)
            }
          }
        }]
      }



    }



  }



  getRowCount() {
    let count = this.props.kyousais.length;
    if (this.state.refresh && count > 0) {
      count--; // hack for update data-grid
      this.setState({
        refresh: false
      });
    }

    return count;
  }






  render() {

    return (
      <div>

        <ReactDataGrid
          // ref={node => this.grid = node}
          enableCellSelect={false}
          enableRowSelect={false}
          enableCellAutoFocus={false}
          columns={this.state.columns}
          rowGetter={(i: number) => this.props.kyousais[i]}

          getCellActions={this.getCellActions}



          rowsCount={this.getRowCount()}
          headerRenderer={true}
          dragable={true}

          // onCellSelected={false}
          // onColumnResize={(idx, width) =>
          //     console.log(`Column ${idx} has been resized to ${width}`)
          // }
          // emptyRowsView={this.EmptyRowsView}
          onRowClick={this.onRowClick}
          // rowSelection={{
          //   showCheckbox: true,
          //   enableShiftSelect: true,
          //   onRowsSelected: this.onRowsSelected,
          //   onRowsDeselected: this.onRowsDeselected,
          //   selectBy: {
          //     isSelectedKey: 'selected'
          //     // indexes: this.state.selectedIndexes
          //   }
          // }}
          onGridSort={(sortColumn: any, sortDirection: any) => { this.sortRows(this.props.kyousais, sortColumn, sortDirection) }
            //
          }
          //onCellSelected={this.getSelectedCell}
          minHeight={window.innerHeight - 260} />
      </div>
    );
  }


}



const mapStateToProps = (state: any) => {
  return {
    // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
    shops: state.masterReducer.shops,
    kyousais: state.kyousaiReducer.kyousais,
    grid_update: state.kyousaiReducer.grid_update,
  }
}
function mapDispatchToProps(dispatch: any) {
  return {
    upload_kyousai_csv(state: any) {
      dispatch(Kyousai.upload_kyousai_csv(state))
    },
    change_search_id(state: any) {
      dispatch(Kyousai.change_search_id(state))
    },
    change_search_modal(state: any) {
      dispatch(Kyousai.change_search_modal(state))
    },
    change_grid_update(state: any) {
      dispatch(Kyousai.change_grid_update(state))
    },
    change_search_detail(state: any) {
      dispatch(Kyousai.change_search_detail(state))
    },
    change_kyousais(state: any) {
      dispatch(Kyousai.change_kyousais(state))
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountingGridComponent);